import { KdsCallout, KdsTextField } from "@kazaar-platform/design-system";
import { RiInformationLine } from "@remixicon/react";
import { useTranslate } from "@tolgee/react";
import { type KeyboardEvent } from "react";
import { useFormContext } from "react-hook-form";
import { type InferredOrderDetailsAddQuoteFormPageSchema } from "@/pages/OrderDetailsAddQuoteFormPage/OrderDetailsAddQuoteFormPage.schema";
import { type GetSearchQuoteStepProps } from "../ModalAddQuote.types";

export const AddQuoteSearchQuoteStep = ({
  hasCommonProduct,
  goNextStep,
}: GetSearchQuoteStepProps) => {
  const { t } = useTranslate();

  const methods = useFormContext<InferredOrderDetailsAddQuoteFormPageSchema>();
  const quoteNumberValue = methods.watch("quoteNumber");

  // Handle Go Next Step on Enter key Press
  const onEnterPress = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      return goNextStep();
    }
  };

  const getErrorMessage = () => {
    if (methods.formState.errors.quoteNumber) {
      return t("inputs.requiredField");
    }
    if (!hasCommonProduct && !methods.formState.errors.quoteNumber) {
      return t("inputs.noCommonProducts");
    }
    return undefined;
  };

  return (
    <div className="flex w-full flex-col gap-6 p-6 px-8">
      <KdsCallout
        state="info"
        title={t("oms.addQuote.stepper.calloutTitle")}
        subtitle={t("oms.addQuote.stepper.calloutSubtitle")}
        iconLeft={RiInformationLine}
      />
      <div className="flex flex-col-reverse gap-8">
        <div className="flex flex-col gap-4">
          <div className="flex flex-row flex-wrap items-center gap-4 md:flex-nowrap">
            <KdsTextField
              label={t("inputs.quoteNumber.label")}
              placeholder={t("inputs.quoteNumber.placeholder")}
              hasError={
                (!!methods.formState.errors.quoteNumber ||
                  hasCommonProduct === false) &&
                !quoteNumberValue
              }
              errorMessage={getErrorMessage()}
              dataCy="quoteNumber"
              errorDataCy="quoteNumberError"
              onKeyDown={onEnterPress}
              {...methods.register("quoteNumber", {
                required: true,
              })}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
